import { defineComponent } from 'vue';
import { deleteCategoryTwelveRecord, getCategoryTwelveRecords } from '@/api/dataentry-api-generated';
import CategoryTwelveDialog from '@/components/CategoryTwelve/CategoryTwelveDialog.vue';
import CategoryTwelveFileUploadDialog from '@/components/CategoryTwelve/CategoryTwelveFileUploadDialog.vue';
import CategoryTwelveDuplicateDialog from '@/components/CategoryTwelve/CategoryTwelveDuplicateDialog.vue';
import DeleteDialog from '@/components/DeleteDialog.vue';
export default defineComponent({
    name: 'CategoryTwelveRecords',
    components: { CategoryTwelveDialog, CategoryTwelveFileUploadDialog, CategoryTwelveDuplicateDialog, DeleteDialog },
    data() {
        return {
            loading: false,
            items: [],
            filter: '',
            selected: [],
            columns: [
                {
                    name: 'action',
                    label: 'EDIT',
                    align: 'center'
                },
                {
                    name: 'duplicate',
                    label: 'Duplicate',
                    align: 'center'
                },
                {
                    field: 'categoryTwelveSupplierLabel',
                    name: 'supplier',
                    label: 'Supplier',
                    sortable: true,
                    align: 'center'
                },
                {
                    field: 'productCategory',
                    name: 'productCategory',
                    label: 'Product Category',
                    sortable: true,
                    align: 'center',
                    format: (val) => val === null ? '-' : val
                },
                {
                    field: 'productClass',
                    name: 'productClass',
                    label: 'Product Class',
                    sortable: true,
                    align: 'center',
                    format: (val) => val === null ? '-' : val
                },
                {
                    field: 'representativeProduct',
                    name: 'representativeProduct',
                    label: 'Representative Product',
                    sortable: true,
                    align: 'center',
                    format: (val) => val === null ? '-' : val
                },
                {
                    field: 'massOfRepresentativeProduct',
                    name: 'massOfRepresentativeProduct',
                    label: 'Mass (Kg)',
                    sortable: true,
                    align: 'center',
                    format: (val) => val === null ? '-' : val
                },
                {
                    field: 'steelMaterialComp',
                    name: 'steelMaterialComp',
                    label: 'Steel',
                    sortable: true,
                    align: 'center',
                    format: (val) => val === null ? '-' : val
                },
                {
                    field: 'plasticMaterialComp',
                    name: 'plasticMaterialComp',
                    label: 'Plastic',
                    sortable: true,
                    align: 'center',
                    format: (val) => val === null ? '-' : val
                },
                {
                    field: 'woodMaterialComp',
                    name: 'woodMaterialComp',
                    label: 'Wood',
                    sortable: true,
                    align: 'center',
                    format: (val) => val === null ? '-' : val
                },
                {
                    field: 'glassMaterialComp',
                    name: 'glassMaterialComp',
                    label: 'Glass',
                    sortable: true,
                    align: 'center',
                    format: (val) => val === null ? '-' : val
                },
                {
                    field: 'copperMaterialComp',
                    name: 'copperMaterialComp',
                    label: 'Copper',
                    sortable: true,
                    align: 'center',
                    format: (val) => val === null ? '-' : val
                },
                {
                    field: 'percentageOfGoodsSoldRecycled',
                    name: 'percentageOfGoodsSoldRecycled',
                    label: '% of Goods Sold Recycled',
                    sortable: true,
                    align: 'center',
                    format: (val) => val === null ? '-' : val
                },
                {
                    field: 'percentageOfGoodsSoldSentToLandfill',
                    name: 'percentageOfGoodsSoldSentToLandfill',
                    label: '% of Goods Sold Sent to Landfill',
                    sortable: true,
                    align: 'center',
                    format: (val) => val === null ? '-' : val
                },
                {
                    field: 'totalNoOfUnitsSold9MonthsActuals',
                    name: 'totalNoOfUnitsSold9MonthsActuals',
                    label: 'No. Units Sold - 9  months',
                    sortable: true,
                    align: 'center',
                    format: (val) => val === null ? '-' : val
                },
                {
                    field: 'noOfUnitsSold9MonthsActuals3MonthsAccruals',
                    name: 'noOfUnitsSold9MonthsActuals3MonthsAccruals',
                    label: 'No. Units Sold - 12  months',
                    sortable: true,
                    align: 'center',
                    format: (val) => val === null ? '-' : val
                }
            ],
            tablePagination: {
                rowsPerPage: 50,
                rowsNumber: 0,
                sortBy: 'supplier',
                descending: false,
                page: 1
            }
        };
    },
    mounted() {
        this.refresh();
    },
    computed: {
        deleteDialogTitle() {
            const length = this.selected.length;
            const item = length > 1 ? 'Category 12 Records' : 'Category 12 Record';
            return `Delete ${length} ${item}`;
        },
        deleteDialogMsg() {
            const length = this.selected.length;
            const record = length > 1 ? 'these records' : 'this record';
            return `Are you sure you want to delete ${record}?`;
        }
    },
    methods: {
        refresh() {
            this.fetch({
                pagination: {
                    page: 1,
                    rowsNumber: this.tablePagination.rowsNumber,
                    sortBy: this.tablePagination.sortBy,
                    descending: this.tablePagination.descending,
                    rowsPerPage: this.tablePagination.rowsPerPage
                }
            });
        },
        async getItems(filter, pageNumber, pageSize, orderByField, orderByAscending) {
            this.loading = true;
            try {
                const result = await getCategoryTwelveRecords({ pageNumber: pageNumber, pageSize: pageSize, orderByField: orderByField, orderByAscending: orderByAscending, deleted: false });
                this.items = this.filterResults(result.items, filter);
                const newPagination = {
                    pageNumber: result.pageNumber,
                    totalNumberOfRecords: result.totalNumberOfRecords
                };
                this.setPagination(newPagination);
                this.loading = false;
            }
            catch (error) {
                this.$log.addError(error);
                this.loading = false;
            }
        },
        edit(uuid) {
            this.$router.push({ name: 'Cat. 12 - EOL Treatment of Sold Products', params: { uuid: uuid } });
        },
        async deleteItems() {
            await Promise.all(this.selected.map(async (i) => {
                try {
                    await deleteCategoryTwelveRecord(i.uuid);
                    this.$log.addMessage('Successfully deleted Category 12 record');
                }
                catch (error) {
                    this.$log.addError(error);
                }
            }));
            this.selected = [];
            this.refresh();
        },
        fetch(props) {
            let { page, rowsPerPage, sortBy, descending } = props.pagination;
            // update local pagination object
            this.tablePagination.page = page;
            this.tablePagination.rowsPerPage = rowsPerPage;
            this.tablePagination.sortBy = sortBy;
            this.tablePagination.descending = descending;
            // if sortBy is null, set to undefined - user has cleared the sort column
            sortBy = sortBy === null ? undefined : sortBy;
            this.getItems(this.filter, page, rowsPerPage, sortBy, !descending);
        },
        setPagination(newPagination) {
            this.tablePagination.page = newPagination.pageNumber;
            this.tablePagination.rowsNumber = newPagination.totalNumberOfRecords;
        },
        filterResults(results, filter) {
            if (filter !== undefined && filter.length > 0) {
                filter = filter ? filter.trim().toLowerCase() : filter;
                const filteredResults = results.filter((x) => {
                    let found = false;
                    // Search each individual 'value' in the object for the specified 'filter'
                    Object.keys(x).forEach(key => {
                        if (typeof x[key] === 'string') {
                            if (x[key].toLowerCase().includes(filter)) {
                                found = true;
                                // found something, stop searching
                            }
                        }
                        else if (typeof x[key] === 'number') {
                            if (x[key].toString().includes(filter)) {
                                found = true;
                                // found something
                            }
                        }
                    });
                    return found;
                });
                return filteredResults;
            }
            else {
                return results;
            }
        }
    }
});
